import { render } from "./IncluirProdutos.vue?vue&type=template&id=358eaf50&scoped=true"
import script from "./IncluirProdutos.vue?vue&type=script&lang=js"
export * from "./IncluirProdutos.vue?vue&type=script&lang=js"

import "./IncluirProdutos.vue?vue&type=style&index=0&id=358eaf50&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3986129723/src/app-csd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-358eaf50"]])

export default __exports__